var React = require('react');

function ProfitInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m60 21.91h-32a3 3 0 0 0 -3 3v27.3a3 3 0 0 0 3 3h18.88l3.71 3.7a2 2 0 0 0 3.41-1.41v-2.29h6a3 3 0 0 0 3-3v-27.3a3 3 0 0 0 -3-3zm-4 23h-24a1 1 0 0 1 0-2h24a1 1 0 0 1 0 2zm0-9.41h-24a1 1 0 0 1 0-2h24a1 1 0 0 1 0 2z","fill":"#9145e3","key":0}),React.createElement("path",{"d":"m48 16.91h-9v-4.41a8 8 0 0 0 -8-8 3 3 0 0 0 -3 3v9.41h-7a3 3 0 0 0 -3-3h-16a1 1 0 0 0 0 2h16a1 1 0 0 1 1 1v23.59a1 1 0 0 1 -1 1h-16a1 1 0 0 0 0 2h16a3 3 0 0 0 3-3h27a3 3 0 0 0 3-3v-17.59a3 3 0 0 0 -3-3zm1 10.59h-5a1 1 0 0 0 0 2h5v4h-5a1 1 0 0 0 0 2h5v2a1 1 0 0 1 -1 1h-27v-19.59h8a1 1 0 0 0 1-1v-10.41a1 1 0 0 1 1-1 6 6 0 0 1 6 6v5.41a1 1 0 0 0 1 1h10a1 1 0 0 1 1 1v2h-5a1 1 0 0 0 0 2h5z","fill":"#fff","key":1})]);
}

ProfitInline.defaultProps = {"id":"Line","height":"512","viewBox":"0 0 64 64","width":"512"};

module.exports = ProfitInline;

ProfitInline.default = ProfitInline;
